// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"ItemsCatalog_searchForm__2mqNW","sertformInputs":"ItemsCatalog_sertformInputs__2puDd"};